/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_Team_Member_AddedInputs */



/**
* | output |
* | --- |
* | "New Team Member Added" |
*
* @param {Options_Notifications_Team_Member_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_team_member_added = /** @type {((inputs?: Options_Notifications_Team_Member_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_Team_Member_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau membre d'équipe ajouté")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Teammitglied hinzugefügt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiunto nuovo membro del team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В команду добавлен новый член.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo miembro del equipo añadido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新团队成员加入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいチームメンバーが追加されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम में नया सदस्य शामिल हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo membro da equipe adicionado")
	return /** @type {LocalizedString} */ ("New Team Member Added")
});